import {Component, ViewChild, AfterViewInit} from '@angular/core';
import {APIService} from "../../services/APIService";
import {AuthService} from "../../services/AuthService";
import {EventRank} from "../../entities/auth/EventRank";
import {BasicEventPlayer} from "../../entities/auth/BasicEventPlayer";
import {FormControl, Validators} from "@angular/forms";
import {MatTabChangeEvent, MatTabGroup} from "@angular/material/tabs";
import {ActivatedRoute} from "@angular/router";
import {Role} from "../../entities/auth/Role";

@Component({
  selector: 'app-rank-list',
  templateUrl: './rank-list.component.html',
  styleUrls: ['./rank-list.component.css']
})
export class RankListComponent implements AfterViewInit {

  ranks: EventRank[] = [];
  players: BasicEventPlayer[] = [];
  roles: Role[] = [];

  columns: string[] = ['player', 'uuid', 'rank', 'entitlements']

  rankControl = new FormControl<EventRank | null>(null, Validators.required);
  entitleControl = new FormControl<Role | null>(null, Validators.required);

  @ViewChild("tab")
  tab: MatTabGroup;

  private pendingSelectedIndex: number | null = null;

  constructor(protected apiService: APIService,
              protected authService: AuthService,
              private route: ActivatedRoute) {
    this.apiService.getRanks().then((a) => {
      const list = Array.isArray(a) ? a : Object.values(a ?? {});
      for (const rank of list as EventRank[]) {
        if (rank.name === 'Default' || rank.name === 'Attendee')
          continue;
        this.ranks.push(rank);
      }

      if ('rank' in route.snapshot.queryParams) {
        const name = route.snapshot.queryParams["rank"];
        for (const rank of this.ranks) {
          if (rank.name.toLowerCase() === name.toLowerCase())
            this.rankControl.setValue(rank)
        }
      }
    });

    this.apiService.listRoles().then((r) => {
      this.roles = r;

      if ('role' in route.snapshot.queryParams) {
        const id = Number(route.snapshot.queryParams["role"]);
        this.pendingSelectedIndex = 1;

        for (const role of this.roles) {
          if (role.id === id)
            this.entitleControl.setValue(role);
        }
      }
    });

    this.rankControl.valueChanges.subscribe((a) => {
      if (a == null)
        return;
      this.apiService.getRankPlayers(a.id).then((players) => this.players = (Array.isArray(players) ? players : Object.values(players ?? {})) as BasicEventPlayer[]);
    })

    this.entitleControl.valueChanges.subscribe((a) => {
      if (a == null)
        return;
      this.apiService.getRolePlayers(a.id).then((players) => this.players = (Array.isArray(players) ? players : Object.values(players ?? {})) as BasicEventPlayer[]);
    })
  }

  ngAfterViewInit(): void {
    if (this.pendingSelectedIndex !== null && this.tab) {
      this.tab.selectedIndex = this.pendingSelectedIndex;
      this.pendingSelectedIndex = null;
    }
  }

  getRankName(player: BasicEventPlayer): string {
    const rank = this.apiService.getPriorityRank(player.ranks);
    if (rank === null)
      return "Default";
    return rank.name;
  }

  getRolesForPlayer(player: BasicEventPlayer): string {
    return player.roles.map((id) => {
      const role = this.roles.find((r) => r.id === id);
      if (role === undefined)
        return "Unknown role";
      return role.name;
    }).join(", ")
  }

  change(event: MatTabChangeEvent) {
    const ranks = event.tab.textLabel === 'Ranks';
    this.players = [];

    if (ranks) {
      const rankValue = this.rankControl.value;
      if (rankValue !== null) {
        this.apiService.getRankPlayers(rankValue.id).then((players) => this.players = (Array.isArray(players) ? players : Object.values(players ?? {})) as BasicEventPlayer[]);
      }
    } else {
      const eValue = this.entitleControl.value;
      if (eValue !== null) {
        this.apiService.getRolePlayers(eValue.id).then((players) => this.players = (Array.isArray(players) ? players : Object.values(players ?? {})) as BasicEventPlayer[]);
      }
    }
  }
}
